import { render, staticRenderFns } from "./PatientRoutine.vue?vue&type=template&id=05cea586&scoped=true"
import script from "./PatientRoutine.vue?vue&type=script&lang=js"
export * from "./PatientRoutine.vue?vue&type=script&lang=js"
import style0 from "./PatientRoutine.vue?vue&type=style&index=0&id=05cea586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cea586",
  null
  
)

export default component.exports